document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.pdp-box').forEach(function(card){

    const dots = card.querySelectorAll('.color-dot');
    const nameBox = card.querySelector('.color-name');

    if(dots.length > 0){

      // default active (first)
      dots[0].classList.add('active');

      dots.forEach(function(dot){

        dot.addEventListener('click', function(){

          // remove active
          dots.forEach(d => d.classList.remove('active'));

          // add active
          this.classList.add('active');

          // change name
          nameBox.textContent = this.dataset.name;

        });

      });

    }

  });

});



function toggleHeaderClass() {
    if (jQuery(window).scrollTop() > 60) {
        jQuery("header").addClass("fix_top");
    } else {
        jQuery("header").removeClass("fix_top");
    }
}

// Run on scroll
jQuery(window).on("scroll", toggleHeaderClass);

// Run on page load
jQuery(document).ready(function() {
    toggleHeaderClass();
});


   jQuery('.hero-slide').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
          pauseOnHover: false, 
        pauseOnFocus: false,
        slidesToScroll: 1
  });


     jQuery('.insta-slide').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
         {
          breakpoint: 1171,
          settings: {
              dots: false,
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1
          }
         },{
            breakpoint: 1050,
            settings: {
                dots: false,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },{
            breakpoint: 800,
            settings: {
                dots: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },{
        breakpoint: 600,
        settings: {
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
  });


  
     jQuery('.rev-slide').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
         {
          breakpoint: 1171,
          settings: {
              dots: false,
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1
          }
         },{
            breakpoint: 1050,
            settings: {
                dots: false,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },{
            breakpoint: 800,
            settings: {
                dots: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },{
        breakpoint: 600,
        settings: {
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
  });



     jQuery('.shop-prod .prod-slide').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
         {
          breakpoint: 1171,
          settings: {
              dots: false,
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1
          }
         },{
            breakpoint: 1050,
            settings: {
                dots: false,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },{
            breakpoint: 800,
            settings: {
                dots: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },{
        breakpoint: 600,
        settings: {
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
  });

  $(".faq-item").click(function() {
// Toggle the answer when clicking on a question
$(this).find(".faq-answer").slideToggle(300);

// Close other answers
$(".faq-item").not(this).find(".faq-answer").slideUp(300);
});  

jQuery('.faq-list .accordion-item').click(function(){
  if( jQuery(this).hasClass('active-drop') ) {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
  } else {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
      jQuery(this).addClass('active-drop');
  }
});


jQuery(document).ready(function () {

    if (jQuery('.big_slide').length && jQuery('.min_slide_root').length) {

        // 🔹 Big Slider
        jQuery('.big_slide').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: false,
            touchMove: false,
            swipe: false,
            fade: false,
             adaptiveHeight: true
        });

        // 🔹 Thumbnail Slider
        jQuery('.min_slide_root').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            touchMove: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1281,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: 768,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: 480,
                    settings: { slidesToShow: 2 }
                }
            ]
        });

        // 🔹 Custom Click → Change Big Slider
        jQuery('.min_slide_root').on('click', '.slick-slide', function () {
            var index = jQuery(this).attr('data-slick-index');
            jQuery('.big_slide').slick('slickGoTo', index);
        });

    } else {
        console.error('Slider elements missing!');
    }

});


jQuery(document).ready(function ($) {

  var $section = $('.as-theart');
  var $left = $('.left-text');
  var $right = $('.right-text');

  $(window).on('scroll', function () {

    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();

    if ($section.length === 0) return;

    var sectionTop = $section.offset().top;
    var sectionHeight = $section.outerHeight();

    if (scrollTop + windowHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {

      var progress = (scrollTop + windowHeight - sectionTop) / (windowHeight + sectionHeight);
      progress = Math.max(0, Math.min(1, progress));

      // 🔥 responsive movement
      var maxMove;

      if (windowWidth > 980) {
        maxMove = 300; // desktop
      } else if (windowWidth > 600) {
        maxMove = 60; // tablet
      } else {
        maxMove = 20; // small mobile
      }

      var move = progress * maxMove;

      $left.css('transform', 'translateX(-' + move + 'px)');
      $right.css('transform', 'translateX(' + move + 'px)');

    } else {
      $left.css('transform', 'translateX(0px)');
      $right.css('transform', 'translateX(0px)');
    }

  });

});


// $(document).ready(function(){

//   $('.menu-drawer__menu-item--mainlist').click(function(e){

//     var $parent = $(this).closest('li');
//     var $submenu = $parent.find('.menu-drawer__menu--childlist');

//     if($submenu.length){
//       e.preventDefault();

//       // close others
//       $('.menu-drawer__menu--childlist').not($submenu).slideUp().removeClass('open');
//       $('.menu-drawer__menu-item--mainlist').not(this).removeClass('active');

//       // toggle current
//       $submenu.stop(true, true).slideToggle().toggleClass('open');
//       $(this).toggleClass('active');
//     }

//   });

// });

// $(document).ready(function(){

//   $(document).on('click', '.slick-slide img', function(){

//     var src = $(this).attr('src') || '';
//     var alt = $(this).attr('alt') || '';

//     // target text box
//     var textBox = $('#dynamic-size-text');

//     // 👉 PEACEOFGOLD image check
//     if(src.toLowerCase().includes('peaceofgold') || alt.toLowerCase().includes('peaceofgold')){

//       textBox.html(`
//         <p><strong>Standard</strong> | 40" x 26.5" | 101.6 x 67.3 cm</p>
//         <p><strong>Medium</strong> | 55" x 36.5" | 139.7 x 92.7 cm</p>
//         <p><strong>Large</strong> | 68" x 45.5" | 172.7 x 115.6 cm</p>
//         <p><strong>Extra Large</strong> | 80" x 53.5" | 203.2 x 135.9 cm</p>
//       `);

//     } else {

//       // default text
//       textBox.html(`
//         <p><strong>Standard</strong> | 40" x 26" | 101.6 x 66 cm</p>
//         <p><strong>Medium</strong> | 55" x 35.5" | 139.7 x 90.2 cm</p>
//         <p><strong>Large</strong> | 68" x 44" | 172.7 x 111.8 cm</p>
//         <p><strong>Extra Large</strong> | 80" x 52" | 203.2 x 132.1 cm</p>
//       `);
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const sizeBox = document.querySelector("#dynamic-size-text-rough");

  if (!sizeBox) return;

  const originalText = `
    <p><strong>Standard</strong> | 44" x 35" | 101.6 x 67.3 cm</p>
    <p><strong>Medium</strong> | 55" x 42" | 139.7 x 92.7 cm</p>
    <p><strong>Large</strong> | 68" x 52" | 172.7 x 115.6 cm</p>
  `;

  const squareText = `
    <p><strong>Standard</strong> | 44" x 44" | 101.6 x 67.3 cm</p>
    <p><strong>Medium</strong> | 55" x 55" | 139.7 x 92.7 cm</p>
    <p><strong>Large</strong> | 68" x 68" | 172.7 x 115.6 cm</p>
  `;

  function updateSizeText() {
    const activeSlide = document.querySelector(".big_slide .slick-current .nws-clr-inner");
    const activeImgId = activeSlide ? activeSlide.getAttribute("data-img-id") : "";

    if (activeImgId === "48000940245229") {
      sizeBox.innerHTML = squareText;
    } else {
      sizeBox.innerHTML = originalText;
    }
  }

  setTimeout(updateSizeText, 500);

  document.querySelector(".big_slide").addEventListener("afterChange", updateSizeText);

  document.addEventListener("click", function () {
    setTimeout(updateSizeText, 300);
  });
});


(function () {
  const sizeBox = document.querySelector("#dynamic-size-text");
  if (!sizeBox) {
    console.log("Size box not found");
    return;
  }

  const originalText = `
    <p><strong>Standard</strong> | 40" x 26" | 101.6 x 66 cm</p>
    <p><strong>Medium</strong> | 55" x 35.5" | 139.7 x 90.2 cm</p>
    <p><strong>Large</strong> | 68" x 44" | 172.7 x 111.8 cm</p>
    <p><strong>Extra Large</strong> | 80" x 52" | 203.2 x 132.1 cm</p>
  `;

  const changedText = `
    <p><strong>Standard</strong> | 40" x 26.5" | 101.6 x 66 cm</p>
    <p><strong>Medium</strong> | 55" x 36.5" | 139.7 x 90.2 cm</p>
    <p><strong>Large</strong> | 68" x 45.5" | 172.7 x 111.8 cm</p>
    <p><strong>Extra Large</strong> | 80" x 53.5" | 203.2 x 132.1 cm</p>
  `;

  function updateSizeText() {
    const activeImg = document.querySelector(".big_slide .slick-current.slick-active img");
    const src = activeImg ? activeImg.getAttribute("src") || "" : "";

    if (src.includes("PEACEOFGOLD")) {
      sizeBox.innerHTML = changedText;
    } else {
      sizeBox.innerHTML = originalText;
    }
  }

  updateSizeText();
  setInterval(updateSizeText, 500);
})();


jQuery(document).ready(function ($) {

  // =========================
  // TOGGLE SUBMENU
  // =========================
  $(document).on('click', '.menu-drawer__menu-item--mainlist', function(e){

    var $parent = $(this).closest('li');
    var $submenu = $parent.find('.menu-drawer__menu--childlist');

    if($submenu.length){

      e.preventDefault();

      // close others
      $('.menu-drawer__menu--childlist')
        .not($submenu)
        .slideUp()
        .removeClass('open');

      $('.menu-drawer__menu-item--mainlist')
        .not(this)
        .removeClass('active');

      // current
      $submenu.stop(true,true)
        .slideToggle()
        .toggleClass('open');

      $(this).toggleClass('active');
    }

  });


  // =========================
  // ACTIVE PARENT
  // =========================
  $('.menu-drawer__menu-item--child.menu-drawer__menu-item--active').each(function(){

    var $child = $(this);

    var $submenu = $child.closest('.menu-drawer__menu--childlist');

    var $parentBtn = $submenu
      .closest('li')
      .find('> .menu-drawer__menu-item--mainlist');

    // open submenu
    $submenu.show().addClass('open');

    // add active class
    $parentBtn.addClass('active');

  });

});

jQuery(document).ready(function ($) {

  $('.menu-drawer__menu-item--active, .menu-drawer__menu-item[aria-current="page"]').each(function () {

    // active child link ka li
    $(this).closest('li').addClass('active');

  });

});